// import React, { useEffect, useState, useContext } from "react";
// import axios from "axios";
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Paper,
//   Container,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { useNavigate } from "react-router-dom";

// import { AuthContext } from "../../AuthContext/AuthContext";
// // import BottomNavbar from "../../Users/Rent Module/BottomNavbar/BottomNavbar";
// import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar"; 

// const BuiltSuitProperties = () => {
//   const navigate = useNavigate();

//   // ✅ Take userId from AuthContext
//   const { userId, logout } = useContext(AuthContext);

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // ✅ userId added to API
//         const res = await axios.get(
//           `https://landnest.net:81/property-request/?userId=${userId}`
//         );

//         setData(res.data);
//         setLoading(false);
//       } catch (err) {
//         setError("Failed to load data");
//         setLoading(false);
//       }
//     };

//     if (userId) {
//       fetchData();
//     }
//   }, [userId]);

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: `
//           linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
//           url('/construction4.png')
//         `,
//         backgroundSize: "cover",
//         backgroundAttachment: "fixed",
//         pb: 8,
//       }}
//     >
//       {/* ===================== TOP BAR ===================== */}
//       <AppBar
//         position="static"
//         elevation={0}
//         sx={{
//           background: `
//             linear-gradient(145deg, rgb(22, 22, 22), rgb(15, 15, 15)),
//             url('/construction5.png')
//           `,
//           color: "#fff",
//         }}
//       >
//         <Toolbar sx={{ minHeight: 64 }}>
//           <IconButton
//             edge="start"
//             onClick={() => navigate(-1)}
//             sx={{
//               color: "#ffffff",
//               backgroundColor: "rgba(255,255,255,0.1)",
//               "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
//             }}
//           >
//             <ArrowBackIosNewIcon />
//           </IconButton>

//           <Typography
//             variant="h6"
//             sx={{ marginLeft: 2, fontWeight: 600, color: "#fff" }}
//           >
//           Built Suit Properties
//           </Typography>
//         </Toolbar>
//       </AppBar>

//       {/* ===================== CONTENT ===================== */}
//       <Container sx={{ py: 2 }}>
//         {loading && (
//           <Typography align="center" sx={{ mt: 3 }}>
//             Loading...
//           </Typography>
//         )}

//         {error && (
//           <Typography color="error" align="center" sx={{ mt: 3 }}>
//             {error}
//           </Typography>
//         )}

//         {!loading &&
//           !error &&
//           data.map((item) => (
//             <Paper
//               key={item.req_id}
//               sx={{
//                 p: 2,
//                 mb: 2,
//                 borderRadius: "12px",
//                 boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//                 background: "rgba(255,255,255,0.85)",
//                 backdropFilter: "blur(10px)",
//               }}
//             >
//               <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                 Looking For:{" "}
//                 <span style={{ color: "green" }}>{item.looking_for}</span>
//               </Typography>

//               <Typography>
//                 <strong>Location:</strong> {item.location}
//               </Typography>

//               <Typography>
//                 <strong>Property Type:</strong> {item.property_type}
//               </Typography>

//               <Typography>
//                 <strong>Budget:</strong> ₹
//                 {item.min_budget.toLocaleString()} - ₹
//                 {item.max_budget.toLocaleString()}
//               </Typography>

//               {item.min_acres > 0 && (
//                 <Typography>
//                   <strong>Acres:</strong> {item.min_acres} - {item.max_acres}
//                 </Typography>
//               )}

//               {(item.length > 0 || item.width > 0) && (
//                 <Typography>
//                   <strong>Size:</strong> {item.length} × {item.width}{" "}
//                   {item.units}
//                 </Typography>
//               )}

//               <Typography sx={{ opacity: 0.7 }}>
//                 <strong>Comment:</strong> {item.comment}
//               </Typography>

//               <Typography sx={{ opacity: 0.5, fontSize: "12px" }}>
//                 Posted on: {new Date(item.created_at).toLocaleString()}
//               </Typography>
//             </Paper>
//           ))}
//       </Container>

//       {/* ===================== BOTTOM NAV ===================== */}
//       <CustomBottomNavbar />
//     </Box>
//   );
// };

// export default BuiltSuitProperties;



import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Card,
  CardContent,
  Avatar,
        CircularProgress, // Added for black spinner

} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../AuthContext/AuthContext";
import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";

const BuiltSuitProperties = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const colors = {
    primary: "#1a1a1a",
    secondary: "#8B7355",
    accent: "#A52A2A",
    background: "#b9a990",
    cardBackground: "#FFFFFF",
    textDark: "#1a1a1a",
    textLight: "#FFFFFF",
    textMuted: "#666666"
  };

  // Format date function similar to reference
  const formatDate = (dateString) => {
    if (!dateString) return "Not specified";
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  };

  // Format currency function
  const formatCurrency = (amount) => {
    if (!amount) return "Not specified";
    const num = Number(amount);
    if (num >= 10000000) return `₹${(num / 10000000).toFixed(1)} Cr`;
    if (num >= 100000) return `₹${(num / 100000).toFixed(1)} L`;
    if (num >= 1000) return `₹${(num / 1000).toFixed(1)} K`;
    return `₹${num}`;
  };

useEffect(() => {
  const fetchData = async () => {
    try {
      const res = await axios.get(
        `https://landnest.net:81/property-request/?userId=${userId}`
      );
      
      // Filter properties by user_id
      const userProperties = res.data.filter(item => 
        String(item.user_id) === String(userId)
      ).reverse(); // Show newest first
      
      setData(userProperties);
      setLoading(false);
    } catch (err) {
      setError("Failed to load built suit properties");
      setLoading(false);
    }
  };
  
  if (userId) {
    fetchData();
  } else {
    setLoading(false);
    setError("User not authenticated");
  }
}, [userId]);

  // Render property detail function similar to reference
  const renderPropertyDetail = (label, value, color = colors.textDark) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 0.5 }}>
      <Typography variant="body2" color={color} sx={{ 
        fontSize: '0.75rem', 
        lineHeight: 1.2, 
        minWidth: 120, 
        flexShrink: 0,
        fontWeight: 'bold'
      }}>
        {label}:
      </Typography>
      <Typography variant="body2" color={colors.textDark} sx={{ 
        fontSize: '0.75rem', 
        lineHeight: 1.2 
      }}>
        {value || "Not specified"}
      </Typography>
    </Box>
  );

   if (loading) {
      return (
        <Box
          sx={{
            backgroundColor: 'rgb(239, 231, 221)',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
          <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
            Loading Bank Built Suit properties...
          </Typography>
        </Box>
      );
    }

  if (error) return (
    <Box sx={{ 
      display: "flex", 
      flexDirection: "column", 
      minHeight: "100vh", 
      backgroundColor: colors.background, 
      justifyContent: "center", 
      alignItems: "center" 
    }}>
      <Typography variant="h6" color="error">
        {error}
      </Typography>
    </Box>
  );

  return (
    <Box sx={{ 
      display: "flex", 
      flexDirection: "column", 
      minHeight: "100vh", 
      backgroundColor: colors.background 
    }}>
      <AppBar position="sticky" sx={{ backgroundColor: colors.primary, color: colors.textLight }}>
        <Toolbar>
          <IconButton onClick={() => navigate(-1)} sx={{ color: colors.textLight }}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2 }}>
            My Built Suit Properties
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 1.5, flex: 1, pb: 10, backgroundColor: colors.background }}>
        {data.length === 0 ? (
          <Typography variant="h6" textAlign="center" sx={{ mt: 4, color: colors.textDark }}>
            No built suit properties found
          </Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {data.map((item) => (
              <Card key={item.req_id} sx={{ 
                borderRadius: 2, 
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)', 
                border: `1px solid #e0e0e0`, 
                overflow: 'hidden' 
              }}>
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                  {/* Header section with ID */}
                  <Box sx={{ 
                    p: 1, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between', 
                    backgroundColor: colors.primary 
                  }}>
                    <Box sx={{ 
                      backgroundColor: "#b9a990", 
                      color: colors.primary,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <Typography variant="h6" fontWeight="bold" sx={{ fontSize: '0.9rem', lineHeight: 1 }}>
                        Request ID: {item.req_id}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ 
                      backgroundColor: colors.cardBackground, 
                      color: colors.primary,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{ lineHeight: 1, fontSize: '0.9rem' }}>
                        Budget: {formatCurrency(item.max_budget)}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ p: 1.5 }}>
                    <Box sx={{ display: 'grid', gap: 0.75 }}>
                      {/* Looking For */}
                      {renderPropertyDetail("Looking For", item.looking_for, colors.secondary)}
                      
                      {/* Property Type */}
                      {renderPropertyDetail("Property Type", item.property_type)}
                      
                      {/* Location */}
                      {renderPropertyDetail("Location", item.location)}
                      
                      {/* Min Budget */}
                      {renderPropertyDetail("Min Budget", `₹${Number(item.min_budget).toLocaleString()}`)}
                      
                      {/* Max Budget */}
                      {renderPropertyDetail("Max Budget", `₹${Number(item.max_budget).toLocaleString()}`)}
                      
                      {/* Min Acres */}
                      {item.min_acres > 0 && renderPropertyDetail("Min Acres", item.min_acres)}
                      
                      {/* Max Acres */}
                      {item.max_acres > 0 && renderPropertyDetail("Max Acres", item.max_acres)}
                      
                      {/* Length */}
                      {item.length > 0 && renderPropertyDetail("Length", `${item.length} ${item.units || ''}`)}
                      
                      {/* Width */}
                      {item.width > 0 && renderPropertyDetail("Width", `${item.width} ${item.units || ''}`)}
                      
                      {/* Size (if both length and width exist) */}
                      {item.length > 0 && item.width > 0 && renderPropertyDetail(
                        "Size", 
                        `${item.length} × ${item.width} ${item.units || ''}`
                      )}
                      
                      {/* Comment */}
                      {item.comment && renderPropertyDetail("Comment", item.comment)}
                      
                      {/* User and Date */}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 0.5 }}>
                        <Avatar sx={{ 
                          width: 16, 
                          height: 16,  
                          fontSize: '0.5rem',
                          mr: 0.5
                        }}>
                          👤
                        </Avatar>
                        <Typography variant="body2" color={colors.textDark} sx={{ 
                          fontSize: '0.75rem', 
                          lineHeight: 1.2, 
                          minWidth: 75, 
                          flexShrink: 0 
                        }}>
                          <strong>USER {userId}</strong>
                        </Typography>
                        <Typography variant="body2" color={colors.textMuted} sx={{ 
                          fontSize: '0.75rem', 
                          lineHeight: 1.2 
                        }}>
                          {formatDate(item.created_at)}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>

      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
        <CustomBottomNavbar />
      </Box>
    </Box>
  );
};

export default BuiltSuitProperties;